import type { DeviceMode } from '@vedalib/editor'
import type {
  TestHotspotFeedbackSchemaType,
  TestHotspotSchemaType,
} from '@vedalib/editor/lib/brand'
import cn from 'classnames'
import React from 'react'

import Icon from 'components/uiKit/Icon'
import type { ElementFeedbackCss, ElementStyleCss } from 'services/Branding/types'

import Check from '../../assets/check.svg?react'
import SpotStyled from '../../styled/SpotStyled'
import type { ISpot } from '../../testHotspotTypes'
import FeedbackIcon from '../FeedbackIcon'
import * as s from './Spot.module.scss'

interface ISpotProps {
  spot: ISpot
  deviceMode: DeviceMode
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  result?: any | null
  hasIcon?: boolean
  styles: ElementStyleCss<TestHotspotSchemaType>
  onDeleteSpot?: (id: string) => void
  active?: boolean
  setActiveSpot?: (id: string | null) => void
  enableDelete?: boolean
  feedback: ElementFeedbackCss<TestHotspotFeedbackSchemaType>
  showFeedbackIcon?: boolean
}

const Spot: React.FC<ISpotProps> = ({
  spot,
  result,
  hasIcon,
  styles,
  onDeleteSpot,
  setActiveSpot,
  active,
  enableDelete,
  feedback,
  showFeedbackIcon,
}) => {
  const { x, y } = spot
  const isTrue = spot.items.length > 0

  const iconContent = showFeedbackIcon ? (
    <FeedbackIcon feedback={feedback} isTrueAnswer={isTrue} styles={styles} />
  ) : hasIcon ? (
    <Check color={styles?.selectedSpot?.color} />
  ) : (
    <div />
  )

  const isAnimated = styles.animation.pulse
  const ringletWidth =
    (typeof styles.spot.width === 'string' ? parseInt(styles.spot.width) : styles.spot.width || 0) +
    8
  const ringletHeight =
    (typeof styles.spot.height === 'string'
      ? parseInt(styles.spot.height)
      : styles.spot.height || 0) + 8

  const onDelete = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    e.preventDefault()
    onDeleteSpot?.(spot.id)
  }

  return (
    <div
      className={s.root}
      style={{
        left: `${x}%`,
        top: `${y}%`,
      }}
    >
      <div className={cn(s.ringWrapper, { [s.enableDelete]: enableDelete })}>
        <div className={s.rings}>
          {isAnimated && !result && (
            <>
              <div
                className={s.ringlet}
                style={{
                  width: ringletWidth,
                  height: ringletHeight,
                  background: styles.spot.color,
                }}
              />
              <div
                className={s.ringlet}
                style={{
                  width: ringletWidth,
                  height: ringletHeight,
                }}
              />
            </>
          )}
        </div>
        <SpotStyled
          $feedback={feedback}
          $isTrue={isTrue}
          $result={result}
          $showFeedbackIcon={showFeedbackIcon}
          $styles={styles}
          onMouseDown={(e) => enableDelete && onDelete(e)}
          onMouseLeave={() => setActiveSpot && setActiveSpot(null)}
        >
          {iconContent}
          {!active && (
            <div className={cn(s.deleteSpot)}>
              <Icon name='otherClose' />
            </div>
          )}
        </SpotStyled>
      </div>
    </div>
  )
}

export default Spot
